import React, { FC } from 'react';

import { IconProps } from 'types/components';

import Icon from './Icon';

const Mail: FC<IconProps> = (props) => (
  <Icon {...props}>
    <path d="M20 21H4a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h16a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3ZM3 7.92V18a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V7.92l-8.43 5.9a1 1 0 0 1-1.14 0Zm.11-2.37L12 11.78l8.89-6.23A1 1 0 0 0 20 5H4a1 1 0 0 0-.89.55Z" />
  </Icon>
);

export default Mail;
